<mat-label *ngIf="label">
  <span [innerHtml]="label"></span>
  <span class="indicator" *ngIf="control && control.hasValidator(required)">*</span>
</mat-label>
